import React from "react";
import { Shield, CheckCircle, Clock } from "lucide-react";

const HeroSection = ({ openPopup }) => {
  return (
    <section id="hero" className="hero-section">
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <div className="hero-text">
          <h1 className="hero-title">
            Protect Your Brand Before It's Too Late
          </h1>
          <p className="hero-subtitle">
            Expert USPTO Trademark Registration Services - Secure Your Brand Identity with America's Trusted Trademark Filing Specialists
          </p>
          <div className="hero-features">
            <div className="hero-feature">
              <Shield className="feature-icon" />
              <span>USPTO Filing Experts</span>
            </div>
            <div className="hero-feature">
              <CheckCircle className="feature-icon" />
              <span>1000+ Trademarks Filed</span>
            </div>
            <div className="hero-feature">
              <Clock className="feature-icon" />
              <span>Fast 24-48hr Processing</span>
            </div>
          </div>
          <div className="hero-buttons">
            <button className="btn-primary" onClick={openPopup}>
              Register My Trademark
            </button>
            <button className="btn-secondary" onClick={openPopup}>
              Get Free Consultation
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
